<template>
  <v-list-item class="link-tile" :style="{'background-color': color}" @click="open">
    <v-list-item-content>
      <v-list-item-title class="menu-item">{{linkname}}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<style>
  .link-tile {
    font-size: 24px !important;
    font-weight: bold !important;
  }
  .menu-item {
    color: #FFFFFF;
  }
</style>

<script>
  export default {
    name: 'link',
    props: {
      linkname: String,
      color: String,
      href: String
    },

    methods: {
      open() {
        window.open(this.href, "_blank");
      },
    },
  }
</script>
